import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import HomePage from "../HomePage";
import AboutPage from "../AboutPage";
import Careers from "../Careers/careers";
import Contact from "../Contact/contact";
import ServicesModule from "../ServicesModule/services";
import ScrollToTop from "../ScrollToTop";
import PrivacyHome from "../PrivacyPolicy/PrivacyHome";
import ErrorHome from "../ErrorPage/errorHome";
import Technology from "../Services/Screens/Technology";
import ServicesPage from '../Serviceslatest/Screens/ServicesPage';

const seoByRoute = {
  "/": {
    title: "Global Spark Tek Solutions | Oracle Consulting & IT Services",
    description:
      "Global Spark Tek Solutions provides Oracle consulting, ERP implementations, cloud advisory, application integration, managed services, testing, and web development for businesses seeking scalable IT solutions.",
  },
  "/about": {
    title: "About Us | Global Spark Tek Solutions",
    description:
      "Learn about Global Spark Tek Solutions, our Oracle expertise, consulting approach, and commitment to delivering scalable business transformation services.",
  },
  "/careers": {
    title: "Careers | Global Spark Tek Solutions",
    description:
      "Explore career opportunities with Global Spark Tek Solutions and join our team of Oracle and IT professionals delivering value-driven digital transformation.",
  },
  "/services": {
    title: "Services | Global Spark Tek Solutions",
    description:
      "Discover Global Spark Tek Solutions services including Oracle ERP, application integration, managed services, testing, cloud consulting, and web development.",
  },
  "/contact": {
    title: "Contact Us | Global Spark Tek Solutions",
    description:
      "Contact Global Spark Tek Solutions to discuss Oracle consulting, ERP implementation, cloud services, integration, testing, and custom web development needs.",
  },
  "/servicepage": {
    title: "Application Integration & IT Services | Global Spark Tek Solutions",
    description:
      "Explore application integration, ERP implementations, managed services, testing, cloud consulting, and web development solutions from Global Spark Tek Solutions.",
  },
  "/technologies": {
    title: "Technology Solutions | Global Spark Tek Solutions",
    description:
      "Explore Oracle APEX, Oracle EBS, Oracle Cloud, Oracle Integration Cloud, React, React Native, and VBCS technology solutions from Global Spark Tek Solutions.",
  },
  "/privacy": {
    title: "Privacy Policy | Global Spark Tek Solutions",
    description:
      "Read the privacy policy for Global Spark Tek Solutions and learn how we handle personal information and business data responsibly.",
  },
};

const setMetaTag = (selector, attribute, value, content) => {
  let tag = document.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, value);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
};

const RouteMetadata = () => {
  const location = useLocation();

  useEffect(() => {
    const { pathname, search } = location;
    const normalizedPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "") || "/";

    let canonicalPath = normalizedPath;
    if ((normalizedPath === "/technologies" || normalizedPath === "/servicepage") && search) {
      const params = new URLSearchParams(search);
      if (params.has("service") || params.has("tab") || params.has("subtab")) {
        canonicalPath = normalizedPath;
      }
    }

    const routeMeta = seoByRoute[canonicalPath] || seoByRoute["/"];
    const domain = "https://www.globalsparkteksolutions.com";
    const canonicalUrl = `${domain}${canonicalPath}`;

    document.title = routeMeta.title;
    setMetaTag('meta[name="description"]', "name", "description", routeMeta.description);
    setMetaTag('meta[property="og:title"]', "property", "og:title", routeMeta.title);
    setMetaTag('meta[property="og:description"]', "property", "og:description", routeMeta.description);
    setMetaTag('meta[property="og:url"]', "property", "og:url", canonicalUrl);
    setMetaTag('meta[name="twitter:title"]', "name", "twitter:title", routeMeta.title);
    setMetaTag('meta[name="twitter:description"]', "name", "twitter:description", routeMeta.description);
    setMetaTag('meta[name="twitter:url"]', "name", "twitter:url", canonicalUrl);

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonicalUrl);
  }, [location]);

  return null;
};

const Navigate = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RouteMetadata />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/services" element={<ServicesModule />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/servicepage" element={<ServicesPage />} />
        <Route path="/technologies" element={<Technology />} />
        <Route path="/privacy" element={<PrivacyHome />} />
        <Route path="*" element={<ErrorHome />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Navigate;

